export default "__VITE_ASSET__DhNvsIx7__"